import Result from "./Result";

export default class ResultsStore {

    constructor() {
        this.results = [];
    }

    //Nice to have: use set results(results) syntax
    setResults(apiResults) {
        apiResults.forEach(
            (apiResult) => {
                let result = new Result(apiResult);
                this.results.push(result);
            }
        )
    }

    //Nice to have: use get results() syntax
    getResults() {
        return this.results;
    }

    clearResults() {
        this.results = [];
    }
}
